import { useQuery } from "@tanstack/react-query";
import { authService } from "@/entities/session/api/authService";
import { queryKeys } from "@/shared/lib/queryKeys";

// Organizações e marca só mudam com uma troca de organização, que recarrega a página.
const STALE = 5 * 60 * 1000; // 5 min

/** Organizações da pessoa; `current` marca a da sessão. */
export function useMyTenants(enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.account.tenants(),
        queryFn: authService.getMyTenants,
        enabled,
        staleTime: STALE,
    });
}

/** Marca pública da organização do slug da URL, antes do login; sem slug, nada é pedido. */
export function usePublicTenantBranding(slug: string | null, enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.account.publicTenant(slug ?? ""),
        queryFn: () => authService.getTenantBySlug(slug ?? ""),
        enabled: enabled && slug !== null,
        staleTime: STALE,
        // 404 é resposta, não falha: slug desconhecido fica com a marca da 7Days.
        retry: false,
    });
}

/** Marca, idioma e moeda da organização da sessão. */
export function useCurrentTenant(enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.account.currentTenant(),
        queryFn: authService.getCurrentTenant,
        enabled,
        staleTime: STALE,
    });
}
